import { z } from 'zod'

export const userProfileResponseSchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string().nullable(),
  avatar: z.string().nullable(),
  createDate: z.coerce.date(),
})

export type UserProfileResponseDto = z.infer<typeof userProfileResponseSchema>
